import { mockData } from '../services/mockData'

const cities = ['Arezzo', 'Siena', 'Firenze', 'Perugia', 'Roma', 'Prato']

// Sede legale + sedi operative dell'anagrafica cliente
export function getClientSites(clientName?: string): string[] {
  if (!clientName) return []
  const client = mockData.getClients().find((c) => c.name === clientName)
  if (!client) return []
  const id = client.id
  const legalCity = cities[id % cities.length]
  const opCity = cities[(id + 2) % cities.length]
  const sites = [
    `Sede legale — Via Roma ${10 + id}, ${legalCity}`,
    `Sede operativa — Zona industriale ${12 + id}, ${opCity}`,
  ]
  if (id % 2 === 0) {
    sites.push(
      `Sede operativa — Via dell'Artigianato ${3 + id}, ${cities[(id + 4) % cities.length]}`,
    )
  }
  return sites
}
